import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import LectureOverview from "./lectureOverview";
import LectureWarmupPdfs from "./lectureWarmups/lectureWarmupPdfs";
import LectureWarmupsList from "./lectureWarmups";
import LectureExerciseSwapVideos from "./lectureExercises/lectureExerciseSwapVideos";
import LectureExerciseCategories from "./lectureExercises";
import LectureExerciseVideos from "./lectureExercises/lectureExerciseVideos";
import { usePermissions } from "../../../../../functions/usePermissions";

function LectureDetails(props) {
  const [exerciseVideosShow, setExerciseVideosShow] = React.useState(false);
  const [exerciseSwapVideosShow, setExerciseSwapVideosShow] = React.useState(false);
  const [warmupPdfsShow, setWarmupPdfsShow] = React.useState(false);
  const [exerciseCategory, setExerciseCategory] = React.useState();
  const [exerciseCategoryVideo, setExerciseCategoryVideo] = React.useState();
  const [lectureWarmupData, setLectureWarmupData] = React.useState({});
  const [loading, setLoading] = React.useState(true);

  const { state } = useLocation();

  const navigate = useNavigate();
  const { hasPermission } = usePermissions();

  useEffect(() => {
    // props.setPageTitleAndSubTitle(state?.lecture?.title, `Here is the details of ${state?.lecture?.title} !`);

    const loader = setTimeout(() => {
      setLoading(false);
    }, 500);
    return () => {
      clearTimeout(loader);
    };
  }, []);

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <button
              className="btn btn-primary"
              onClick={() => {
                props?.setLectureVideosShow(true);
                props?.setShowLectureDetails(false);
              }}
            >
              <i className="fas fa fa-arrow-circle-left mr-3"></i>
              Back to {state?.lecture?.title}
            </button>
          </div>
          <div className="col-12">
            <div className="card">
              {loading ? (
                <div className="text-center py-5">
                  <div className="spinner-border text-black" role="status" aria-hidden="true"></div>
                </div>
              ) : (
                <div className="card-body" style={{ minHeight: "300px" }}>
                  <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                    {hasPermission("view-lecture-overview") && (
                      <li class="nav-item">
                        <a
                          class="nav-link active"
                          id="pills-home-tab"
                          data-toggle="pill"
                          href="#LectureOverview"
                          role="tab"
                          aria-controls="LectureOverview"
                          aria-selected="true"
                        >
                          Overview
                        </a>
                      </li>
                    )}
                    {hasPermission("view-lecture-warmups") && (
                      <li class="nav-item">
                        <a
                          className={!hasPermission("view-lecture-overview") ? "nav-link active" : "nav-link"}
                          id="pills-profile-tab"
                          data-toggle="pill"
                          href="#LectureWarmUp"
                          role="tab"
                          aria-controls="LectureWarmUp"
                          aria-selected="false"
                        >
                          Warm-up
                        </a>
                      </li>
                    )}
                    {hasPermission("view-lecture-exercises") && (
                      <li class="nav-item">
                        <a
                          className={
                            !hasPermission("view-lecture-overview") && !hasPermission("view-lecture-warmups") ? "nav-link active" : "nav-link"
                          }
                          id="pills-contact-tab"
                          data-toggle="pill"
                          href="#WeekDayLectures"
                          role="tab"
                          aria-controls="WeekDayLectures"
                          aria-selected="false"
                        >
                          Routine
                        </a>
                      </li>
                    )}
                  </ul>
                  <div class="tab-content" id="pills-tabContent">
                    {hasPermission("view-lecture-overview") && (
                      <div className="tab-pane fade show active" id="LectureOverview" role="tabpanel" aria-labelledby="LectureOverview-tab">
                        <LectureOverview />
                      </div>
                    )}
                    {hasPermission("view-lecture-warmups") && (
                      <div
                        className={!hasPermission("view-lecture-overview") ? "tab-pane fade show active" : "tab-pane fade"}
                        id="LectureWarmUp"
                        role="tabpanel"
                        aria-labelledby="LectureWarmUp-tab"
                      >
                        {warmupPdfsShow ? (
                          <LectureWarmupPdfs lectureWarmupData={lectureWarmupData} setWarmupPdfsShow={setWarmupPdfsShow} />
                        ) : (
                          <LectureWarmupsList setWarmupPdfsShow={setWarmupPdfsShow} setLectureWarmupData={setLectureWarmupData} />
                        )}
                      </div>
                    )}
                    {hasPermission("view-lecture-exercises") && (
                      <div
                        className={
                          !hasPermission("view-lecture-overview") && !hasPermission("view-lecture-warmups")
                            ? "tab-pane fade show active"
                            : "tab-pane fade"
                        }
                        id="WeekDayLectures"
                        role="tabpanel"
                        aria-labelledby="WeekDayLectures-tab"
                      >
                        {exerciseVideosShow ? (
                          <LectureExerciseVideos
                            setExerciseVideosShow={setExerciseVideosShow}
                            exerciseCategory={exerciseCategory}
                            setExerciseSwapVideosShow={setExerciseSwapVideosShow}
                            setExerciseCategoryVideo={setExerciseCategoryVideo}
                          />
                        ) : exerciseSwapVideosShow ? (
                          <LectureExerciseSwapVideos
                            exerciseCategoryVideo={exerciseCategoryVideo}
                            setExerciseVideosShow={setExerciseVideosShow}
                            setExerciseSwapVideosShow={setExerciseSwapVideosShow}
                          />
                        ) : (
                          <LectureExerciseCategories setExerciseVideosShow={setExerciseVideosShow} setExerciseCategory={setExerciseCategory} />
                        )}
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default LectureDetails;
